export default __webpack_public_path__ + "static/media/BrandLive_Logo.388f5a77.svg";